var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
//@ts-ignore
import { useRoot } from 'baobab-react/hooks';
import * as baobab from './baobab';
export function withRoot(Child) {
    return function (props) {
        var Root = useRoot(baobab.root);
        return (React.createElement(Root, null,
            React.createElement(Child, __assign({}, props))));
    };
}
